module.exports = __webpack_public_path__ + "static/media/client11.543432fb.jpeg";